export default __webpack_public_path__ + "23871b0b06273fa06ff5bb803400aff8.svg";